import {
  number,
  object,
  string,
  null as zNull,
  type infer as zInfer,
} from "zod/v4";

export const setKatanaIntegration = {
  name: "setKatanaIntegration" as const,
  input: object({ accessToken: string(), restockLocationId: number() }),
  output: zNull(),
};

export type SetKatanaIntegrationInput = zInfer<
  typeof setKatanaIntegration.input
>;
